// Utility to test Google Maps API key validity
import { GOOGLE_MAPS_API_KEY } from '../config/env';

export const testGoogleMapsApiKey = async () => {
  if (!GOOGLE_MAPS_API_KEY) {
    console.warn('⚠️ Google Maps API key is missing - Maps functionality will be limited');
    return false;
  }

  // Note: We only verify the key exists. The actual Maps JavaScript API will be tested
  // when the map component loads. Direct API calls (like Geocoding) may fail due to
  // HTTP referrer restrictions, but the Maps JavaScript API should still work.
  console.log('✅ Google Maps API Key is configured');
  console.log('💡 The map will load when you navigate to a page with maps.');
  console.log('💡 If maps don\'t load, check API restrictions in Google Cloud Console.');
  
      return true;
};

// Auto-test the API key in development (just verify it exists)
if (process.env.NODE_ENV === 'development') {
  testGoogleMapsApiKey();
}